export default __webpack_public_path__ + "static/media/box-1Open.a92b84e2.jpg";